import axios from 'axios';
import { cleanJSON } from './utils';

export const wp_namespace = WP_Settings.home_url + '/wp-json/wp/v2';
export const baykeeper_namespace = WP_Settings.home_url + '/wp-json/baykeeper/v1';

/**
 * API call
 *
 * @param Array {args}    string {method}       HTTP method.
 *                        string {route}        The route.
 *                        function {request}    The function to run when response is received.
 *                        Object {data}         Params for the request. Optional.
 */
export const apiCall = ( args ) => {

    // No method
    if( ! args.hasOwnProperty( 'method' ) ) {
        console.log( ' Error - Need to specify a method for HTTP request' );
        return;
    }
    // No Route
    else if( ! args.hasOwnProperty( 'route' ) ) {
        console.log( 'Error - no route specified' );
        return;
    }
    // No success function
    else if( ! args.hasOwnProperty( 'success' ) ) {
        console.log( 'Error - what do we do after the request is successful?' );
        return;
    }

    // No POST data
    if( ! args.hasOwnProperty( 'data' ) ) {
        args.data = null;
    }

    // No GET params
    if( ! args.hasOwnProperty( 'params' ) ) {
        args.params = null;
    }

    // Make the request.
    axios( {
        method: args.method,
        url: baykeeper_namespace + '/' + args.route,
        params: args.params
    } )
    .catch( server_error => {
        console.log( 'Server Error: ', server_error );
    } )
    .then( response => {

        if( response.status !== 200 ) {
            console.log( 'Uh Oh... ', response );
            return;
        }

        // We're good, do something with the data!
        args.success( cleanJSON( response.data ) );

    } );

}


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/api.js